// src/index.ts
import { createContext } from "react";
if (!globalThis.WixReactContext) {
  globalThis.WixReactContext = createContext(void 0);
}
var WixContext = globalThis.WixReactContext;
export {
  WixContext
};
